import { categories } from "@/mocks/comics";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <i className="ri-grid-fill"></i> 按类型找连载
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
            主题分类
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            无论你偏好热血、悬疑还是治愈，都能快速找到对味的连载，持续盯紧最新话进度。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#updates"
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-primary-600">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="flex items-center justify-between text-base font-bold text-foreground-950">
                  {cat.name}
                  <span className="text-xs font-normal text-foreground-500">{cat.count} 部在追</span>
                </h3>
                <p className="mt-1 text-sm text-foreground-600">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-foreground-400 transition-transform group-hover:translate-x-1"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}